"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "knocked", {
  enumerable: true,
  get: function get() {
    return _knocked["default"];
  }
});
var _knocked = _interopRequireDefault(require("./knocked"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }